

//Teams version Tab.jsx

import { useContext } from "react";
import { TeamsFxContext } from "../teams/Context.jsx";
import { BrowserRouter as Router, Route, Redirect, Switch } from "react-router-dom";

import LegacyCalendar from "../modules/LegacyCalendar/CalendarTest/Calendar.jsx";

import MapDefault from "../modules/Map/MapDefault.jsx";
import MyBooking from "../modules/MyBooking/MyBookingUI.jsx";
import Colleagues from "../modules/Colleagues/Colleagues.jsx";
import SettingReact from "../modules/Setting/SettingReact.jsx";
import Emp1 from "../modules/EmployeeRoles/EmpDesign.jsx"
import InactiveUserResponseHandler from "../modules/Common/InactiveUserResponseHandler.jsx";

// import "../assets/css/bootstrap.min.css";
// import "../assets/css/all.min.css";
// import "../assets/css/common.css";
// import "../assets/css/jquery.mCustomScrollbar.css";
// import "../assets/css/language-dropdown.css";
// import "../assets/css/style.css";
// import "../assets/css/responsive.css";

import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/css/bootstrap.min.css";

export default function Tab() {

  //   useEffect(() => {
  //   startEventLogger();     // Start event tracking

  //   return () => {
  //     stopEventLogger();    // Cleanup event tracking
  //   };
  // }, []);

  useContext(TeamsFxContext);
  return (
    <Router>
        <InactiveUserResponseHandler />
        {/* <IFrame/> */}
        <Switch>
          {/* Enable this before Staging update */}
          
          {/* <Route exact path="/Login" component={Login} /> */}
          <Route path="/calendar" component={LegacyCalendar} />
          {/* <Route path="/calendars" component={Calendar} /> */}

          {/* <Route path="/weeklycalendar" component={TestCalendarTesting} /> */}
          
          {/* <Route path="/mapcanvas" component={MapCanvasZone} /> */}
          <Route path="/map" component={MapDefault} />
          <Route path="/newbooking" component={MapDefault} />
          {/* <Route path="/mapcanvas" component={MapGridZone} /> */}


          <Route path="/booking" component={MyBooking} />
          <Route path="/colleagues" component={Colleagues} />
          
          <Route path="/roles" component={Emp1} />
          {/* <Route path="/roles" component={Emp1} /> */}
          {/* <Route path="/roles" component={EmployeeRoles} /> */}

          <Route path="/setting" component={SettingReact} />
          
          <Redirect from="/" to="/calendar" />
          {/* <Redirect from="/" to="/" /> */}
        </Switch>
    </Router>
  );
}
